import React from "react";
import { heroChips, initialTestimonials, mockupImage, offerConfig, stats } from "../../data/megapack";
import { CTAButton } from "../CTAButton";
import { E } from "../Emoji";
import { TestimonialCard } from "../TestimonialCard";
import { TrustRow } from "../TrustRow";
export function Hero() {
  const trust = [`🛡️ Garantía ${offerConfig.guaranteeDays} días`, "🔒 Pago seguro", ...offerConfig.paymentMethods.map(m => `💳 ${m}`)];
  return <header className="bg-abyss" data-id="element-179" data-mp="ms7prv4qm7w4">
      <div className="mx-auto max-w-2xl px-5 pb-12 pt-6 text-center" data-id="element-180" data-mp="qv459cyzdnvu">
        <p className="text-sm font-black uppercase tracking-wide text-bright" data-id="element-181" data-mp="vmccq3gr2z6d">
          <E data-id="element-182" data-mp="vofbpczvs2n8">🧺 Senvoria Digital™</E>
        </p>
        <h1 className="mt-5 text-[clamp(1.6rem,7.6vw,2.5rem)] font-black leading-[1.08] tracking-tight text-white md:text-5xl" data-id="element-183" data-mp="10loyekvvy07d">
          <span className="block whitespace-nowrap" data-id="element-184" data-mp="15m38e8h1rk81">¿Falló tu lavarropas?</span>
          <span className="block whitespace-nowrap text-bright" data-id="element-185" data-mp="1akoa6cby6byl">Sabé qué hacer.</span>
        </h1>

        <img src={mockupImage} alt="Megapack Lavarropas — Fallas y soluciones" className="mx-auto mt-6 h-auto w-full max-w-[420px]" data-id="element-186" data-mp="9oub02gsr5z3" />

        <p className="mt-6 text-sm font-bold text-sky" data-id="element-187" data-mp="3vur6cn7oh8vk">
          El sistema práctico para tu lavarropas en Argentina — Por síntomas — Paso a paso
        </p>
        <p className="mx-auto mt-3 max-w-md text-lg font-bold leading-snug text-white" data-id="element-188" data-mp="3rv8ndwzf37vd">
          Diagnóstico + comprobaciones + soluciones seguras. Sin buscar. Sin adivinar. Sin perder tiempo.
        </p>

        <ul className="mt-4 flex flex-wrap justify-center gap-1.5" data-id="element-189" data-mp="nhahxectjo5a">
          {heroChips.map(c => <li key={c} className="rounded-full border border-line/70 px-2.5 py-1 text-xs font-bold text-white" data-id="element-190" data-mp="im4n1q1fuz52">
              <E data-id="element-191" data-mp="1b4s4mvh87w1e">{c}</E>
            </li>)}
        </ul>

        <div className="mx-auto mt-7 max-w-md" data-id="element-192" data-mp="1b6378ryxqxqx">
          <CTAButton href="#elegi" data-id="element-193" data-mp="16dju1w45u4mn">🧺 → QUIERO MI MEGAPACK AHORA</CTAButton>
        </div>
        <div className="mt-4" data-id="element-194" data-mp="30m75y47miu5k">
          <TrustRow items={trust} data-id="element-195" data-mp="30mys6ofbzfj6" />
        </div>
      </div>

      <section aria-label="Datos y opiniones" className="bg-navy/40" data-id="element-196" data-mp="35l0j1vj00j57">
        <dl className="mx-auto grid max-w-2xl grid-cols-2 gap-y-7 px-5 py-10 text-center md:grid-cols-4" data-id="element-197" data-mp="35k8rqwwfp7kq">
          {stats.map(s => <div key={s.label} data-id="element-198" data-mp="2vuxfj1e93msm">
              <dd className="text-5xl font-black leading-none text-white" data-id="element-199" data-mp="2vtw611cvv8d0">{s.value}</dd>
              <dt className="mt-1.5 text-sm font-bold text-sky" data-id="element-200" data-mp="2huedcawgvayd">
                <E data-id="element-201" data-mp="2muis9whq7xmh">{s.label}</E>
              </dt>
            </div>)}
        </dl>
        <div className="mx-auto max-w-2xl space-y-3 px-5 pb-12" data-id="element-202" data-mp="27x9o227bqzdc">
          {initialTestimonials.map(t => <TestimonialCard key={t.name} testimonial={t} data-id="element-203" data-mp="2cw32pxyckwf3" />)}
        </div>
      </section>
    </header>;
}